import styled from 'styled-components';
import { DeprecatedGrid as Grid } from '@simplywallst/ui-core';
import { media } from '@simplywallst/ui-core';

export const RecentSectionUpdatesWrapper = styled(Grid)`
  position: relative;
  background: ${({ theme }) => theme.color.phantom};
  border-radius: ${({ theme }) => theme.x1spacePx}px;
  padding: ${({ theme }) => theme.x2spacePx}px;
  width: 100%;
  height: 100%;
  overflow: hidden;
`;

export const FeedContainer = styled('div')`
  /*Make height less than the KeyInformation section to allow content to overflow and crop*/
  height: 200px;
  width: 100%;
  display: flex;
  flex-direction: column;
  margin: 0px ${({ theme }) => -theme.x1spacePx}px;

  ${media.smDown`
    padding-bottom: ${({ theme }) => theme.x2spacePx}px;
  `}
`;

export const ShadowBlur = styled('div')`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: ${({ theme }) => theme.x11spacePx}px;

  background: linear-gradient(
    360deg,
    #202833 50%,
    rgba(32, 40, 51, 0.3) 105.11%
  );
`;
